<template lang="pug">
v-form#paymentMultiForm(
  ref="paymentMultiForm",
  @submit.prevent="doSave",
  lazy-validation
)
  v-container(grid-list-md)
    v-layout(wrap)
      v-flex(lg2, md2, xs12)
        v-text-field(
          dense,
          v-model="list.customerId",
          v-numeric-only,
          label="No. Virtual Account",
          required,
          :rules="[(v) => !!v || 'Masukan no virtual account']"
        )
      v-flex(lg5, md5, xs12)
        v-text-field(
          dense,
          v-model="list.description",
          label="Nama Virtual Account",
          required,
          :rules="[(v) => !!v || 'Masukan nama virtual account']"
        )
    .ma-2.menu-btn(justify-center, style="text-align: center")
      v-btn.mx-1(@click="doCancel") Kembali
        v-icon mdi-arrow-left
      v-btn.mx-1(
        color="btnprimary white--text",
        type="submit",
        form="paymentMultiForm"
      ) Simpan
        v-icon mdi-content-save-outline
</template>
<script>
export default {
  name: "FPaymentMultiListForm",
  props: ["productId", "productGroup", "merchantId"],
  data() {
    return {
      list: {
        customerId: "",
        description: "",
        data: {
          merchantId: "",
        },
      },
    };
  },
  mounted() {
    this.doReset();
  },
  methods: {
    doReset() {
      if (this.$refs.paymentMultiForm) {
        this.$refs.paymentMultiForm.resetValidation();
      }
      this.list = {
        customerId: "",
        description: "",
        data: {
          merchantId: "",
        },
      };
    },
    doSave() {
      if (this.$refs.paymentMultiForm.validate()) {
        this.list.data.merchantId = this.merchantId;
        this.$emit("list", this.list);
        this.doReset();
      }
    },
    doCancel() {
      this.$emit("cancel");
      this.doReset();
    },
  },
};
</script>